import styled from "styled-components";

export const CompetitionFilterPanel = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.theme.segmentedControlBackground};
  border-radius: 0.8rem;
`;
